export default function SearchPrioritizeFactory($q, moment) {
    let fn = this;

    fn.findPrioritizedLanes = (legacyHouses) => {
        let tmpLanes = [];

        legacyHouses.ParentLanes.map((parentLane) => {
            parentLane.Lanes.map((lane) => {
                if (lane.Priority) {
                    tmpLanes.push(lane);
                }
            });

            return tmpLanes.sort((a, b) => {
                // if a.priority is null put it in the end
                // else sort by priority (lowest number = top priority)
                return a.Priority ? (a.Priority > b.Priority ? 1 : -1) : 1;
            });
        });

        let extraxtedPeriods = [];
        tmpLanes.map((lane) => {
            /** Prices or Periods ? */

            /**
             * This should really be refactored
             */
            let periods = [];

            if (lane.Prices) {
                periods = lane.Prices;
            }

            if (lane.Periods) {
                periods = lane.Periods;
            }

            periods.map((period) => {
                period._laneName = lane.LaneName; // legacy basket needs this
                period._LaneID = lane.LaneID;
                period.selected = false;
                period._lanePriority = lane.Priority;
                period._FromPrice = lane.FromPrice;
                period._House = lane.House;

                if (!period.AlreadyReserved) {
                    extraxtedPeriods.push(period); // add to prio lane
                }
            });
        });

        // Filter all periods from the future
        extraxtedPeriods = extraxtedPeriods.filter((x) =>
            moment(x.AvailableFrom).isBefore()
        );

        const groupedBySlots = groupByTimeslot(sortByTime(extraxtedPeriods));

        return $q.resolve(groupedBySlots);
    };

    const sortByTime = (periods) => {
        return periods.sort((a, b) => {
            a = moment(a.BookingStart);
            b = moment(b.BookingStart);
            return a.diff(b);
        });
    };

    const groupByTimeslot = (arr) => {
        let lastKey = "";
        return arr.reduce((acc, period) => {
            if (lastKey !== period.BookingStart) {
                lastKey = period.BookingStart;

                const startFormat = moment(period.BookingStart).format("HH:mm");
                const endFormat = moment(period.BookingEnd).format("HH:mm");

                acc.push({
                    slot: {
                        start: startFormat,
                        end: endFormat,
                        BookingStart: period.BookingStart,
                    },
                    periods: [],
                    // resources: [],
                    // parentResouce: period._resource.parentId,
                });
            }

            acc[acc.length - 1].periods.push(period);

            return acc;
        }, []);
    };

    return fn;
}
